import React from "react";
import { useTranslation } from "react-i18next";
import logoImg from "../Images/logo40.jpg";
import spauLogoImg from "../Images/Logoithad.jpg";
import "./Footer.css";

const NAV = [
  { en: "Home",          ar: "الرئيسية",         href: "/Home" },
  { en: "About SPAR",   ar: "عن SPAR",           href: "/About-us" },
  { en: "Artists",      ar: "الفنانون",           href: "/ArtistsList" },
  { en: "News & Events",ar: "الأخبار والفعاليات", href: "/Events" },
  { en: "Gallery",      ar: "المعرض",             href: "/gallery" },
  { en: "Forum",        ar: "المنتدى",            href: "/Forum" },
];

const OFFICES = [
  { en: "Organisation & Membership", ar: "مكتب التنظيم والعضوية",  href: "#" },
  { en: "Academic Office",           ar: "المكتب الأكاديمي",        href: "#" },
  { en: "Union Office",              ar: "مكتب النقابة",            href: "#" },
  { en: "Political Guidance Office", ar: "مكتب التوجيه السياسي",   href: "#" },
];

const LINKS = [
  { en: "Women Artists — Sudan",      ar: "فنانات السودان",              href: "http://lessedra.com/previous.php?exh_id=45" },
  { en: "Arab Culture Fund",          ar: "صندوق الثقافة العربية",       href: "https://www.arabculturefund.org/" },
  { en: "Sudan Memory Project",       ar: "مشروع ذاكرة السودان",         href: "https://www.sudanmemory.org/" },
  { en: "Sharjah Art Foundation",     ar: "مؤسسة الشارقة للفنون",        href: "https://sharjahart.org/" },
  { en: "Sponsor a Sudanese Artist",  ar: "ادعم فناناً سودانياً",        href: "https://sponsorasudaneseartist.wordpress.com/" },
];

const SOCIALS = [
  { label: "Facebook",  href: "https://www.facebook.com/spartripe",         icon: "f"  },
  { label: "Twitter",   href: "https://twitter.com/ArtistsRally",           icon: "t"  },
  { label: "Instagram", href: "https://www.instagram.com/spar.sudan/",      icon: "in" },
  { label: "YouTube",   href: "https://www.youtube.com/@SudanesePlasticArtistsRa-oh2zd/featured", icon: "yt" },
  { label: "Blog",      href: "https://spar-sudan.blogspot.com/",           icon: "b"  },
];

function SocialIcon({ icon }) {
  const icons = {
    f:  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>,
    t:  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"/></svg>,
    in: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>,
    yt: <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58A2.78 2.78 0 0 0 3.41 19.6C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.95-1.95A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"/><polygon fill="#fff" points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02"/></svg>,
    b:  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>,
  };
  return icons[icon] || null;
}

export default function Footer() {
  const { i18n } = useTranslation();
  const isAr = i18n.language === "ar" || i18n.language?.startsWith("ar");
  const year = new Date().getFullYear();

  return (
    <footer className="spar-footer" dir={isAr ? "rtl" : "ltr"}>

      {/* ── Top social bar ── */}
      <div className="ft-social-bar">
        <div className="ft-social-inner">
          <span className="ft-social-label">
            {isAr ? "تواصل معنا:" : "Connect with us:"}
          </span>
          <div className="ft-socials">
            {SOCIALS.map((s) => (
              <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer"
                className="ft-social-link" aria-label={s.label}>
                <SocialIcon icon={s.icon} />
                <span>{s.label}</span>
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* ── Main footer grid ── */}
      <div className="ft-main">
        <div className="ft-main-inner">

          {/* Brand column */}
          <div className="ft-col ft-col-brand">
            <a href="/Home" className="ft-brand-link">
              <img src={logoImg} alt="SPAR" className="ft-logo" />
              <div>
                <div className="ft-brand-name">SPAR Hub</div>
                <div className="ft-brand-sub">
                  {isAr ? "تجمع التشكيليين السودانيين" : "Sudanese Plastic Artists Rally"}
                </div>
              </div>
            </a>
            <p className="ft-brand-desc">
              {isAr
                ? "SPAR Hub هو المكان الذي يجتمع فيه الفنانون التشكيليون في السودان لعرض أعمالهم وتبادل الخبرات والترويج للفن السوداني على المستوى العالمي."
                : "The SPAR Hub is where visual artists in Sudan gather to showcase their works, exchange experiences and promote Sudanese art globally."}
            </p>
            <div className="ft-contact-list">
              <div className="ft-contact-item">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
                {isAr ? "الخرطوم، السودان · ص.ب 10012" : "Khartoum, Sudan · P.O. Box 10012"}
              </div>
              <div className="ft-contact-item">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.77 1.2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8 8a16 16 0 0 0 6 6l.86-.86a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21.82 16.92z"/></svg>
                +249 912 345 675
              </div>
              <div className="ft-contact-item">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                info@spar-sudan.org
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div className="ft-col">
            <h4 className="ft-col-title">{isAr ? "التنقل" : "Navigation"}</h4>
            <ul className="ft-links">
              {NAV.map((n) => (
                <li key={n.en}>
                  <a href={n.href} className="ft-link">{isAr ? n.ar : n.en}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Offices */}
          <div className="ft-col">
            <h4 className="ft-col-title">{isAr ? "مكاتب SPAR" : "SPAR Offices"}</h4>
            <ul className="ft-links">
              {OFFICES.map((o) => (
                <li key={o.en}>
                  <a href={o.href} className="ft-link">
                    {isAr ? o.ar : o.en}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Art Resources */}
          <div className="ft-col">
            <h4 className="ft-col-title">{isAr ? "مصادر فنية" : "Art Resources"}</h4>
            <ul className="ft-links">
              {LINKS.map((l) => (
                <li key={l.en}>
                  <a href={l.href} target="_blank" rel="noopener noreferrer" className="ft-link">
                    {isAr ? l.ar : l.en}
                  </a>
                </li>
              ))}
            </ul>
          </div>

        </div>
      </div>

      {/* ── Bottom bar ── */}
      <div className="ft-bottom">
        <div className="ft-bottom-inner">
          <p className="ft-copy">
            {isAr
              ? `© 2021–${year} تجمع التشكيليين السودانيين — SPAR Hub. جميع الحقوق محفوظة.`
              : `© 2021–${year} Sudanese Plastic Artists Rally — SPAR Hub. All rights reserved.`}
          </p>
          <p className="ft-credit">
            {isAr ? "تصميم وتطوير" : "Designed & Developed by"}{" "}
            <span className="ft-credit-name">Amged Higazi</span>
          </p>
          <a href="https://spar-sudan.blogspot.com/" target="_blank"
            rel="noopener noreferrer" className="ft-bottom-link">
            spar-sudan.blogspot.com
          </a>
          <a href="https://spau-artists.org/" target="_blank"
            rel="noopener noreferrer" className="ft-bottom-link ft-bottom-link-spau">
            <img src={spauLogoImg} alt="SPAU" className="ft-spau-logo" />
            {isAr ? "موقع SPAU" : "SPAU Website"}
          </a>
        </div>
      </div>

    </footer>
  );
}
